function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  fill: "#00b09d",
  d: "M 43.6781 1.00256 C 36.5823 1.00256 31.6223 6.46511 31.6223 12.9871 V 13.0533 C 31.6223 19.5752 36.5163 24.9715 43.6121 24.9715 C 50.7078 24.9715 55.6678 19.509 55.6678 12.9871 V 12.9208 C 55.6678 6.39889 50.7738 1.00256 43.6781 1.00256 Z M 48.5673 10.6791 L 47.8082 15.1437 C 47.7658 15.3991 47.6244 15.6261 47.4122 15.7727 C 47.2472 15.8909 47.0539 15.9524 46.8511 15.9524 C 46.7993 15.9524 46.7427 15.9477 46.6861 15.9382 C 46.158 15.8484 45.8044 15.3423 45.894 14.8174 L 46.2571 12.6702 L 40.2315 16.9551 C 40.0665 17.0733 39.8732 17.1348 39.6705 17.1348 C 39.3546 17.1348 39.0623 16.9835 38.8784 16.7233 C 38.5672 16.2835 38.6709 15.6781 39.1094 15.366 L 45.1349 11.0811 L 42.9944 10.7169 C 42.4664 10.627 42.1127 10.121 42.2023 9.59602 C 42.2825 9.1278 42.6832 8.78728 43.1594 8.78728 C 43.2113 8.78728 43.2679 8.79201 43.3245 8.80147 L 47.7752 9.56291 C 48.2986 9.64331 48.6569 10.1494 48.5673 10.6791 Z"
}));

var SvgArrowLogo = function SvgArrowLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    fill: "none",
    viewBox: "31 0 25 25",
    height: 75,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowLogo.ad17a48f.svg";
export { ForwardRef as ReactComponent };